module.exports = __webpack_public_path__ + "static/4-31034f73fe43f08338600197073c9d1d.png";